/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const FACEBOOK_ONETIME_OPTOUT_DISPLAY_TYPE = 'Opt FB User out'
const FACEBOOK_ONETIME_OPTOUT_WIDGET_TYPE = 'FB_OPT_OUT_ONE_TIME'
const FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'

const isFacebookOneTimeOptOutAction = R.propEq(
  'type',
  FACEBOOK_ONETIME_OPTOUT_DISPLAY_TYPE
)

const isPlainTextResponse = R.pipe(
  R.prop('fbOptOutOneTimeAutoResponseImageUrl'),
  R.either(R.isNil, R.isEmpty)
)

const constructPlainTextResponse = R.applySpec({
  type: R.always(FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE),
  message: {
    message: {
      text: R.prop('fbOptOutOneTimeAutoResponseText')
    },
    recipient: {
      id: R.always('${senderId}')
    },
    messaging_type: R.always('RESPONSE')
  }
})

const constructImageTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE),
  message: {
    message: {
      attachment: {
        type: R.always('template'),
        payload: {
          elements: [
            {
              title: R.prop('templateTitle'),
              subtitle: R.prop('fbOptOutOneTimeAutoResponseText'),
              image_url: R.prop('fbOptOutOneTimeAutoResponseImageUrl'),
              default_action: {
                url: R.prop('templateActionUrl'),
                type: R.always('web_url'),
                webview_height_ratio: R.always('tall')
              }
            }
          ],
          template_type: R.always('generic')
        }
      }
    },
    recipient: {
      id: R.always('${senderId}')
    }
  }
})

const constructGenericTemplateAction = R.cond([
  [isPlainTextResponse, constructPlainTextResponse],
  [R.T, constructImageTemplateAction]
])

const constructCustomTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_SEND_DM_INNER_ACTION_WIDGET_TYPE),
  isCustomTemplate: R.always(true),
  message: R.pipe(
    R.prop('customDmTemplate'),
    JSON.parse,
    R.merge({ recipient: { id: '${senderId}' } })
  )
})

const convertFacebookOneTimeOptOutActionToWidgetAction = R.applySpec({
  type: R.always(FACEBOOK_ONETIME_OPTOUT_WIDGET_TYPE),
  failure: R.always([]),
  success: [
    R.cond([
      [R.propEq('action', 'TEMPLATE_GENERIC'), constructGenericTemplateAction],
      [R.propEq('action', 'TEMPLATE_CUSTOM'), constructCustomTemplateAction]
    ])
  ]
})

export {
  isFacebookOneTimeOptOutAction,
  convertFacebookOneTimeOptOutActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-onetime-optout.js